<template>
  <Docs url="/docs_es.pdf" />
</template>

<script>
import Docs from '@/components/Docs.vue';

export default {
  name: 'DocsSpanish',
  components: { Docs },
};
</script>